import {
  PortfolioStatusActions,
  PortfolioStatusActionTypes,
} from './PortfolioStatusActions';
import { PortfolioStatus } from '../../model/PortfolioStatus';

export class Portfolio {
  accountId: string;
  clientAccountCurrency: string;
  cashPosition: number;
  netEquityPosition: number;
  netOpenPosition: number;
  unrealizedProfitOrLoss: number;
  cac: string;
  redisResponseEnabled: boolean;
  initialThreshold: number;
  callThreshold: number;
  closeThreshold: number;
  marginLevelPercentage: number;
  haircutValue: number;
  marginRequirements: number;
}

export interface PortfolioStatusState {
  total: number;
  records: Array<PortfolioStatus>;
  portfolio: Portfolio;
  message: string;
  status: string;
}

export const initialState: PortfolioStatusState = {
  total: 0,
  records: [],
  portfolio: null,
  message: null,
  status: null,
};

export function portfolioStatusReducer(
  state: PortfolioStatusState = initialState,
  action: PortfolioStatusActions,
): PortfolioStatusState {
  switch (action.type) {
    case PortfolioStatusActionTypes.InitPortfolioSummary: {
      return {
        ...state,
        portfolio: action.payload.portfoliosummary,
      };
    }
    case PortfolioStatusActionTypes.InitGroupUserPortfolio: {
      return {
        ...state,
        portfolio: action.payload.portfoliosummary,
        records: mapPortfolioRecords(action.payload.portfoliopositions),
      };
    }
    case PortfolioStatusActionTypes.InitPortfolioStatuses: {
      return {
        ...state,
        total: action.payload.total,
        records: mapPortfolioRecords(action.payload.records),
        message: action.payload.message,
        status: action.payload.status,
      };
    }
  }
  return state;
}

const mapPortfolioRecords = (records: Array<PortfolioStatus>) => {
  return records.map((r) => {
    return {
      ...r,
      cashPosition: Number(r.cashPosition.toString().replaceAll(',', '')),
      netEquityPosition: Number(
        r.netEquityPosition.toString().replaceAll(',', ''),
      ),
      netEquityCacPosition: Number(
        r.netEquityCacPosition.toString().replaceAll(',', ''),
      ),
      tradePosition: Number(r.tradePosition.toString().replaceAll(',', '')),
      netOpenPosition: Number(r.netOpenPosition.toString().replaceAll(',', '')),
      haircutValue: r.cascadingTrancheValues
        ? Number(
            r.cascadingTrancheValues.totalHaircutValueCac
              .toString()
              .replaceAll(',', ''),
          )
        : 0,
    };
  });
};

export const initPortfolioState = (state: PortfolioStatusState) => state;
export const initPortfolioSummaryState = (state: PortfolioStatusState) =>
  state.portfolio;
export const initPortfolioStatusesState = (state: PortfolioStatusState) =>
  state.records;
